// extracted by mini-css-extract-plugin
export default {"headerBar":"KI-z","pointsSection":"LI-z","goToDashboard":"MI-z"};